import {
  type POSADeliveryJavaDTO,
  POSADeliveryStatus
} from "@tootsweet/model/lottery/POSADelivery";
import { tt } from "../../utils/i18n/i18n";
import { type POSATypeJavascriptDTO } from "@tootsweet/model/lottery/POSAType";

export const getColorForStatus = (delivery: POSADeliveryJavaDTO) => {
  switch (delivery.status) {
    case POSADeliveryStatus.DeliveryFailed:
    case POSADeliveryStatus.Pending:
    case POSADeliveryStatus.ArtworkIssue:
      return "red";
    case POSADeliveryStatus.Designed:
    case POSADeliveryStatus.ToPrint:
    case POSADeliveryStatus.Printing:
    case POSADeliveryStatus.Printed:
    case POSADeliveryStatus.ToShip:
    case POSADeliveryStatus.NeedsRedesign:
      return "#ffaa00";
    case POSADeliveryStatus.Shipped:
    case POSADeliveryStatus.CarrierUpdateAvailable:
      return "blue";
    case POSADeliveryStatus.DeliveredAtPickupPoint:
    case POSADeliveryStatus.DeliveredAtNeighbours:
    case POSADeliveryStatus.Delivered:
      return "green";
    case POSADeliveryStatus.Canceled:
      return "grey";
  }
  return "#000000";
};

export function ongoingFilter(delivery: POSADeliveryJavaDTO) {
  switch (delivery.status) {
    case POSADeliveryStatus.Designed:
    case POSADeliveryStatus.Pending:
    case POSADeliveryStatus.ToPrint:
    case POSADeliveryStatus.Printing:
    case POSADeliveryStatus.Printed:
    case POSADeliveryStatus.ToShip:
    case POSADeliveryStatus.Shipped:
      return true;
    default:
      return false;
  }
}

export function finishedFilter(delivery: POSADeliveryJavaDTO) {
  switch (delivery.status) {
    case POSADeliveryStatus.Delivered:
    case POSADeliveryStatus.DeliveredAtNeighbours:
    case POSADeliveryStatus.DeliveredAtPickupPoint:
    case POSADeliveryStatus.DeliveryFailed:
    case POSADeliveryStatus.CarrierUpdateAvailable:
    case POSADeliveryStatus.ArtworkIssue:
    case POSADeliveryStatus.Canceled:
      return true;
    default:
      return false;
  }
}

export function redesignFilter(delivery: POSADeliveryJavaDTO) {
  switch (delivery.status) {
    case POSADeliveryStatus.NeedsRedesign:
      return true;
    default:
      return false;
  }
}

export const getDisplayNameForStatus = (delivery: POSADeliveryJavaDTO) => {
  switch (delivery.status) {
    case POSADeliveryStatus.Pending:
      return tt("posa_preparing");

    case POSADeliveryStatus.Designed:
    case POSADeliveryStatus.Printing:
    case POSADeliveryStatus.ToPrint:
    case POSADeliveryStatus.Printed:
      return tt("posa_printing_ongoing");

    case POSADeliveryStatus.ToShip:
      return tt("posa_to_ship");

    case POSADeliveryStatus.Shipped:
      return tt("posa_shipped");

    case POSADeliveryStatus.Delivered:
      return tt("posa_delivered");

    case POSADeliveryStatus.DeliveredAtNeighbours:
      return tt("posa_delivered_at_neighbours");

    case POSADeliveryStatus.DeliveredAtPickupPoint:
      return tt("posa_delivered_at_pickup_point");

    case POSADeliveryStatus.DeliveryFailed:
      return tt("posa_delivery_failed");

    case POSADeliveryStatus.CarrierUpdateAvailable:
      return tt("posa_carrier_update");

    case POSADeliveryStatus.ArtworkIssue:
      return tt("posa_artwork_issue");

    case POSADeliveryStatus.Canceled:
      return tt("posa_canceled");

    case POSADeliveryStatus.NeedsRedesign:
      return tt("needs_redesign");
  }

  return tt("unknown");
};

export const buildLabelForDelivery = (
  delivery: POSADeliveryJavaDTO,
  posaTypes: POSATypeJavascriptDTO[]
) => {
  const type = posaTypes.find((pt) => pt._id === delivery.plvTypeId);

  if (type == null) {
    return tt("unknown");
  }

  return `${type.name}`;
};
